<template>
  <div
    id="app"
    v-cloak
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title
      if (from.name === 'Login') {
        window.location.reload()
      }
    }
  }
}
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
/* .el-table__body-wrapper {
  max-height: calc(100vh * 0.8 - 80px);
  overflow-y: auto;
} */
.icon-greenUp,
.icon-redDown {
  display: inline-block;
  vertical-align: baseline;
  font-size: 12px;
  transform: scale(0.8);
}
.ys-a-pot:hover {
  cursor: pointer;
}
</style>
